import { motion } from "framer-motion";
import { SidebarActions } from "@/components/layout/SidebarActions";
import Button from "@scripts/react/components/Button";
import { BuildStep, Flow, DeployStep } from "@/types/flows";
import { useAnalytics } from "@/contexts/AnalyticsContext";
import { useAuth } from "@/contexts/AuthContext";
import { useFlow } from "@/contexts/FlowContext";
import { useFlowState } from "@/hooks/useFlowState";
import { AnalyticsFlowEvent } from "@/analytics/types";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useCurrentMedia } from "@/store";
import { usePageNavigationShortcut } from "@/hooks/usePageNavigationShortcut";
import { MetricsSnippet } from "@/components/flow/deploy/MetricsSnippet";
import { DEFAULT_DURATION } from "@/constants/motion";

export const IntegrateSidebarActions = ({
    previousFlow,
    previousStep
}: {
    previousFlow: Flow;
    previousStep: BuildStep | DeployStep;
}) => {
    const { task, reset } = useFlow();
    const { flow, step } = useFlowState();
    const { track } = useAnalytics();
    const { user } = useAuth();
    const navigate = useNavigate();
    const currentMedia = useCurrentMedia();

    const handleBackClick = useCallback(() => {
        track({
            event: AnalyticsFlowEvent.BACK,
            data: { task, from: { flow, step }, to: { flow: null, step: null } }
        });

        navigate("/");
        reset();
    }, [track, task, flow, step, navigate, reset]);

    // Keyboard shortcut: Command + Left Arrow

    return (
        <>
            {/* Removing for now until we have a better Rapid <-> sales pipeline */}
            {/* {user && (
                <div className="flex flex-col gap-1">
                    <p className="text-sm text-tertiary">Want to run your model on the edge?</p>
                    <a
                        href="https://calendly.com/d/cwng-fqd-5xz/chat-with-the-rapid-team"
                        target="_blank"
                        className="text-sm"
                        rel="noreferrer"
                    >
                        Talk with our team.
                    </a>
                </div>
            )} */}
            <SidebarActions>
                <MetricsSnippet />

                <div className="flex min-h-9 items-center" aria-hidden={!currentMedia?.file}>
                    {!!currentMedia?.file ? (
                        <motion.div
                            key="back-button"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: DEFAULT_DURATION.slower, ease: "easeOut" }}
                            className="w-full"
                        >
                            <Button type="secondary" onClick={handleBackClick} className="w-full">
                                <i className="far fa-undo"></i>
                                <span>Create New Model</span>
                            </Button>
                        </motion.div>
                    ) : (
                        <div className="h-9" />
                    )}
                </div>
            </SidebarActions>
        </>
    );
};
